import { useQuery } from "react-query";
import {
  getGoogleAnalyticsRealTimeReport,
  getGoogleAnalyticsReportByCountry,
} from "../../api/google-analytics/google-analytics.api";
import { useEffect, useState } from "react";

export const useGetGoogleAnalyticsReportByCountry = (
  startDate,
  endDate,
  url
) => {
  return useQuery(`get-google-analytics-report`, () => {
    return getGoogleAnalyticsReportByCountry(startDate, endDate, url);
  });
};

export const useGetGoogleAnalyticsRealTimeReport = () => {
  const [queryId, setQueryId] = useState(`get-google-analytics-real-time-report ${Date.now()}`);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setQueryId(`get-google-analytics-real-time-report ${Date.now()}`);
    }, 3 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return useQuery(queryId, () => {
    return getGoogleAnalyticsRealTimeReport();
  });
};
